module.exports = __webpack_public_path__ + "img/MK.5f0ef7c0.png";